import React from 'react';
import BarcodeLabelNew from "./BarcodeLabelNew";
import IntoBarcodeLable from "./IntoBarcodeLable";

const PaperWidthToUse = (props) => {

  debugger
  const cssJustInThisPage = `
    .paperWidthToUse{
        display: table;
        /*width: ${props.barcodeWidth * 3.5}mm !important;*/
        
         width: ${props.paperWidth}mm !important;
         max-height:${props.barcodeLength}mm;
       
        
        /* justify-content: space-around;*/
        /*justify-content: flex-start;*/
        margin: 0 auto;
        /*height: ${props.barcodeLength * 3}mm ;*/
        /*flex-wrap:wrap;*/
       /* align-items: center;*/
        overflow: scroll;
        
    }
    .singleBarcodeWidthAndHeight__wrapper{
        display:inline-block;
        direction:ltr;
        width: ${props.barcodeWidth - 0.1}mm !important;
        height: ${props.barcodeLength - 2}mm !important;
        padding:0;
        margin:0;
        overflow: hidden;
         
    }
    .singleBarcodeWidthAndHeight{
       display: flex; 
       justify-content: space-around;
        flex-direction: row-reverse;
        flex-wrap: nowrap;
        /*background:#bcbcbc;*/
        /*border-right:1px solid;*/
        height: ${props.barcodeLength - 2}mm !important;
    }
    .barcode-spec{
    width:100%;
    width: ${props.barcodeWidth * 0.8}mm;
    text-align: center; 
    
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}
        .product-name {
            line-height:11px;
            font-size: ${props.productFont}px;
            width: ${props.barcodeWidth * 0.8}mm;
            height: 30%;
            overflow:hidden;
            display: flex;
            text-align: center;
            align-items: center;
            justify-content: center;
              
        } 
        .product-price {
              /* font-size: 5px;*/
              font-size:${props.priceFont}px;
              font-weight:700;
        }
.barcode-opt{
    display: flex;
    writing-mode: vertical-rl;
    font-size: 10px !important;
    justify-content: space-around;
    width:20%;
    align-items: center;
    font-weight: 700;
    }
    div.page
      {
        page-break-after: always !important;
        page-break-inside: avoid !important;
      }
    @media print{
        @page {
            size: ${props.paperWidth}mm ${props.barcodeLength}mm !important;
        }
        
        .paperWidthToUse{
         width: ${props.paperWidth}mm !important;
         max-height:${props.barcodeLength}mm;
        /*display: flex;*/
        /*justify-content: space-around;*/
        /*justify-content: flex-start;*/
        /*flex-wrap:wrap;*/
        overflow: visible;
        }
    }
    `;


  return (
    <>
      <style>{cssJustInThisPage}</style>
      <div className={"paperWidthToUse"}>
        {
          props.data.map((v, index) =>
            <>
              <div className={"singleBarcodeWidthAndHeight__wrapper"}>
                <IntoBarcodeLable
                  productName={v.productName}
                  productPrice={v.productPrice}
                  productCode={v.productCode}
                  barcodeLength={v.barcodeLength}
                  barcodeWidth={v.barcodeWidth}
                  displayProductCodeValue={v.displayProductCodeValue}
                  productColor={v.productColor}
                  productSize={v.productSize}
                />
              </div>
              {(index + 1) % (v.barcodeCount)===0 && <>
                <div className={"page"}></div>
              </>}
            </>
          )
        }
      </div>
    </>
  );
};

export default PaperWidthToUse;
